import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef } from "react";

const ServiceInformation = ({
  serviceName,
  setInfoSectionOpen
}) => {

  const articleRef = useRef(null);

  useEffect(() => {
    const article = articleRef.current;
    if (!article) return;

    let startY = article.getBoundingClientRect().top + window.scrollY;
    let currentY = 0;
    let targetY = 0;
    let frameId = null;

    const animate = () => {
      currentY += (targetY - currentY) * 0.5;

      if (Math.abs(targetY - currentY) < 0.5) {
        currentY = targetY;
        article.style.transform = `translate3d(0, ${currentY}px, 0)`;
        frameId = null;
        return;
      }

      article.style.transform = `translate3d(0, ${currentY}px, 0)`;
      frameId = requestAnimationFrame(animate);
    };

    const STICKY_OFFSET = 130; // Height of your sticky element in px
    const GAP = 12;            // Space below the sticky element

    const handleScroll = () => {
      const triggerPoint = startY - STICKY_OFFSET - GAP;

      targetY = Math.max(0, window.scrollY - triggerPoint);

      if (frameId === null) {
        frameId = requestAnimationFrame(animate);
      }
    };

    // Recalculate the original position when the component opens.
    startY = article.getBoundingClientRect().top + window.scrollY;

    // Set the correct initial position immediately.
    article.style.transform = "translate3d(0, 0, 0)";
    handleScroll();

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (frameId !== null) cancelAnimationFrame(frameId);
    };
  }, []);

  const serviceDescriptions = {
    'PT and Nutrition':
      <div className="text-base">
        <p className="mb-4">Personal training and nutrition guidance from a qualified PT:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Exercise & Nutrition Guidance and Advice</li>
          <li>Live Online Classes</li>
          <li>Personal Training Plans tailored to their goals</li>
          <li>Pre-recorded Workouts</li>
          <li>Webinars</li>
          <li>Ask the PT - Expert Advice direct from our expert</li>
        </ul>
      </div>,
    'Nurse Support':
      <div className="text-base">
        <p className="mb-4">Our NMC-registered nurses are on hand to offer support:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Patient can speak to a nurse for advice on minor health issues</li>
          <li>Menopause Support: Our nurses can provide webinars as well as 1-to-1 support</li>
        </ul>
      </div>,
    'Physiotherapy':
      <div className="text-base">
        <p className="mb-4">Physiotherapy services to support physical health:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>We have a wide range of physiotherapy resources to assist with treatment</li>
          <li>We can provide treatment online and in person</li>
        </ul>
      </div>,
    'Mindfulness':
      <div className="text-base space-y-3">
        <p className="mb-4">A programme to help practice mindfulness and reduce stress:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Mastering Mindfulness: A four-week course designed for education professionals, helping staff build resilience, manage stress and anxiety and improve focus and overall wellbeing</li>
          <li>Common mindfulness FAQs answered by Mindfulness Expert, June</li>
        </ul>
      </div>,
    'Counselling':
      <div className="text-base">
        <p>Our BACP registered counsellors provide confidential, individual therapy sessions which are delivered safely and appropriately and available whether they are still working in school or absent through illness. The need for therapy does not need to be work related</p>
      </div>,
  }

  return (
    <article
      ref={articleRef}
      className="flex-1 rounded-lg border border-gray-300 bg-white shadow-md will-change-transform"
    >
      <div className="flex items-center justify-between gap-3 border-b border-gray-200 px-3 py-4 md:px-4">
        <h2 className="text-xl font-semibold text-gray-900">
          {serviceName}
        </h2>

        <button
          type="button"
          onClick={() => setInfoSectionOpen(false)}
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-400"
          aria-label="Close information section"
        >
          <FontAwesomeIcon icon={faXmark} className="h-4 w-4" />
        </button>
      </div>

      {/* Description */}
      <div className="p-3 md:p-4">
        <p className="whitespace-pre-line text-sm leading-relaxed text-gray-700">
          {serviceDescriptions[serviceName] || "No description available."}
        </p>
      </div>
    </article>
  )

}

export default ServiceInformation;